import type { StrainImage } from '@shared';

export interface HeroViewerState {
  images: StrainImage[];
  index: number;
  image: StrainImage | null;
  hasMultiple: boolean;
}

export function resolveHeroViewerState(
  images: readonly StrainImage[],
  primaryImageId: string | null,
  selectedImageId: string | null,
  failedImageIds: ReadonlySet<string>,
): HeroViewerState {
  const orderedImages = [...images];
  const designatedPrimaryIndex = primaryImageId
    ? orderedImages.findIndex((image) => image.id === primaryImageId)
    : -1;
  if (designatedPrimaryIndex > 0) {
    const [designatedPrimary] = orderedImages.splice(designatedPrimaryIndex, 1);
    orderedImages.unshift(designatedPrimary!);
  }

  const usableImages = orderedImages.filter(
    (image) => !failedImageIds.has(image.id),
  );

  const selectedIndex = selectedImageId
    ? usableImages.findIndex((image) => image.id === selectedImageId)
    : -1;

  const primaryIndex = primaryImageId
    ? usableImages.findIndex((image) => image.id === primaryImageId)
    : -1;

  const index =
    selectedIndex >= 0
      ? selectedIndex
      : primaryIndex >= 0
        ? primaryIndex
        : 0;

  return {
    images: usableImages,
    index,
    image: usableImages[index] ?? null,
    hasMultiple: usableImages.length > 1,
  };
}

export function getRelativeHeroImageId(
  images: readonly StrainImage[],
  currentIndex: number,
  offset: number,
): string | null {
  if (images.length < 2) {
    return images[0]?.id ?? null;
  }

  const nextIndex =
    (currentIndex + offset + images.length) % images.length;

  return images[nextIndex]?.id ?? null;
}
